import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';

interface Props {
  onClick: () => void;
  disabled?: boolean;
}

function CancelButton({ onClick, disabled = false }: Props) {
  return (
    <button
      className="px-5 py-2.5 bg-card text-foreground border border-border rounded transition-all hover:bg-muted disabled:opacity-50 disabled:cursor-not-allowed"
      style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
      onClick={onClick}
      disabled={disabled}
      data-intercom-target="builder-v2-cancel-button"
    >
      <T kind="Cancel" />
    </button>
  );
}

export default observer(CancelButton);
